import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

export default function MobileNav({ mobileMenuOpen, seccion, handleNavClick, onClose }) {
  const navItems = [
    "inicio",
    "nosotros",
    "beneficios",
    "servicios",
    "contactanos",
    "descargar",
  ];

  return (
    <AnimatePresence>
      {mobileMenuOpen && (
        <>
          {/* Backdrop overlay */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="mobile-nav-backdrop-ini"
            onClick={onClose || (() => handleNavClick(seccion))}
          />
          {/* Sidebar */}
          <motion.div
            initial={{ x: "-100%" }}
            animate={{ x: 0 }}
            exit={{ x: "-100%" }}
            transition={{ type: "tween", duration: 0.3, ease: "easeInOut" }}
            className="mobile-nav-ini"
          >
            <div className="mobile-nav-header-ini">
              <span className="mobile-nav-title-ini">Menú</span>
              <button
                className="mobile-nav-close-ini"
                onClick={onClose || (() => handleNavClick(seccion))}
                aria-label="Cerrar menú"
              >
                <X size={22} />
              </button>
            </div>
            <ul>
              {navItems.map((item) => (
                <li
                  key={item}
                  className={seccion === item ? "active-ini" : ""}
                  onClick={() => handleNavClick(item)}
                >
                  {item.charAt(0).toUpperCase() + item.slice(1)}
                </li>
              ))}
              <li>
                <Link to="/login" className="mobile-nav-link-ini">
                  Login
                </Link>
              </li>
            </ul>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}